export default function getGeometryType(file) {
  const isPolygon = ({ type }) => ['Polygon', 'MultiPolygon'].includes(type);
  const isLineString = ({ type }) => ['LineString', 'MultiLineString'].includes(type);
  const isPoint = ({ type }) => ['Point', 'MultiPoint'].includes(type);

  const isCollection = ({ type }) => ['FeatureCollection', 'GeometryCollection'].includes(type);

  if (file.type === 'FeatureCollection') {
    if (file.features.length) {
      if (file.features.every((feature) => isLineString(feature.geometry))) return 'LineString';
      if (file.features.every((feature) => isPolygon(feature.geometry))) return 'Polygon';
      if (file.features.every((feature) => isPoint(feature.geometry))) return 'Point';
      return null;
    }
    return null;
  }

  if (file.type === 'GeometryCollection') {
    if (file.geometries.length) {
      if (file.geometries.every(isLineString)) return 'LineString';
      if (file.geometries.every(isPolygon)) return 'Polygon';
      if (file.geometries.every(isPoint)) return 'Point';
      return null;
    }
    return null;
  }

  if (file.type === 'Feature') {
    if (isCollection(file.geometry)) {
      return getGeometryType(file.geometry);
    }
    return file.geometry.type;
  }
  if (file.type) return file.type;

  return null;
}
